import React from "react";
import {
  View,
  FlatList,
  StyleSheet,
  Dimensions,
  ActivityIndicator,
} from "react-native";
import Text from "@components/AppText";
import { connect } from "react-redux";
import colors from "@constants/color";
import { format } from "date-fns";
import { actions as prodActions } from "@reducers/productReducer";
import Button from "@components/Button";
import t from "@constants/localization";
import { REQUEST_PRODUCT } from "../../constants/analyticsEvents";

import testIds from "../../constants/testIds";

const PATH = "screens/Search/ProductsRequests";

const { width } = Dimensions.get("window");

class ProductRequests extends React.Component {
  componentDidMount() {
    setTimeout(() => {
      this.props.fetchProductRequests();
    }, 0);
  }

  renderProductItem = ({ request_product, created_at }, index = 0) => {
    const requestCreatedAt = format(new Date(created_at), "do MMM");
    return (
      <View style={styles.itemContainer}>
        <Text fontType="content2" style={styles.createdAt}>
          {requestCreatedAt}
        </Text>
        <Text fontType="content1" style={{ color: colors.lightBlack }}>
          {request_product}
        </Text>
      </View>
    );
  };

  get headerComponent() {
    return (
      <View
        style={[
          styles.itemContainer,
          {
            backgroundColor: colors.primary,
            alignItems: "center",
            width: width * 0.95,
          },
        ]}
      >
        <Text
          style={[
            styles.text,
            { flex: 1, color: colors.white, fontWeight: "bold" },
          ]}
        >
          {"Sr no."}
        </Text>
        <Text
          style={[
            styles.text,
            { flex: 4, color: colors.white, fontWeight: "bold" },
          ]}
        >
          {t(`${PATH}/description`)}
        </Text>
        <Text
          style={[
            styles.text,
            { flex: 2, color: colors.white, fontWeight: "bold" },
          ]}
        >
          {t(`${PATH}/requestedAt`)}
        </Text>
      </View>
    );
  }

  get emptyComponent() {
    return (
      <View style={styles.mainContainer}>
        <Text>{t(`${PATH}/noProductRequests`)}</Text>
      </View>
    );
  }

  renderSeparator = ({ highlighted, leadingItem }) => {
    return <View style={styles.seperator} />;
  };

  componentWillUnmount() {
    this.props.resetProductRequests();
  }

  get renderLoader() {
    return (
      <View
        style={{
          flex: 1,
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <ActivityIndicator size="large" color={colors.primary} />
      </View>
    );
  }

  get renderProductRequestsList() {
    return (
      <FlatList
        data={this.props.productRequests}
        renderItem={({ item, index }) => this.renderProductItem(item, index)}
        keyExtractor={(item) => item.id}
        showsVerticalScrollIndicator={false}
        // ListHeaderComponent={this.headerComponent}
        ItemSeparatorComponent={this.renderSeparator}
        ListEmptyComponent={this.emptyComponent}
      />
    );
  }

  render() {
    const { isFetchingProductRequests } = this.props;
    return (
      <View
        style={styles.mainContainer}
        testID={testIds.product_request_container}
      >
        {isFetchingProductRequests
          ? this.renderLoader
          : this.renderProductRequestsList}

        <View style={styles.addUserBtn}>
          <Button
            testID={testIds.request_product_btn}
            onPress={() =>
              this.props.navigation.navigate("AddProductRequest", {
                fromScreen: "Requested Items",
              })
            }
            btnText={t(`${PATH}/requestProduct`)}
            eventName={REQUEST_PRODUCT}
            eventPayload={{
              screen: "Requested Items",
            }}
          />
        </View>
      </View>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchProductRequests: () =>
      dispatch(prodActions.fetchRequestForProductRequest()),
    resetProductRequests: () => dispatch(prodActions.resetProductRequests()),
  };
};

const mapStateToProps = ({
  products: { productRequests, isFetchingProductRequests },
}) => {
  return {
    productRequests,
    isFetchingProductRequests,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductRequests);

const styles = StyleSheet.create({
  mainContainer: {
    flex: 1,
    backgroundColor: colors.primaryBg,
    alignItems: "center",
  },
  itemContainer: {
    backgroundColor: colors.white,
    width,
    paddingHorizontal: 10,
    paddingVertical: 15,
  },
  text: {
    textAlign: "left",
  },
  addUserBtn: {
    borderRadius: 20,
    justifyContent: "center",
    alignItems: "center",
    position: "absolute",
    elevation: 10,
    right: 20,
    bottom: 20,
    overflow: "hidden",
    width: width / 2.5,
    height: 40,
  },
  createdAt: {
    textAlign: "left",
    marginBottom: 10,
  },
  message: {
    textAlign: "left",
    flex: 1,
    flexWrap: "wrap",
  },
  seperator: {
    height: 1,
    backgroundColor: colors.lighterBlack,
    marginHorizontal: 10,
  },
});
